<!--
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-04 10:43:38
 * @Description: 手机号脱敏
 * @FilePath: /DecryptIdCardV2.vue
-->
<template>
  <span class="decrypt">
    <template v-if="phone">
      <span class="flex_1">{{ (state.showEye ? phone : state.result) || '--' }}</span>
      <LoadingOutlined v-show="state.loading" class="ml-4" style="font-size: 16px; color: var(--primary-color)" />
      <EyeInvisibleTwoTone
        v-show="!state.loading && state.showEye"
        @click="getCardId"
        class="real-user-show"
        :two-tone-color="primaryColor"
      />
      <EyeTwoTone
        v-show="!state.loading && !state.showEye"
        @click="getCardId"
        class="real-user-show"
        :two-tone-color="primaryColor"
      />
    </template>
    <template v-else>
      --
    </template>
  </span>
</template>
<script setup lang="ts" name="DecryptIdCard">
  import { computed, reactive } from 'vue'
  import { EyeTwoTone, EyeInvisibleTwoTone, LoadingOutlined } from '@ant-design/icons-vue'
  import getPhoneService from '@/service/api/getPhone'
  import { isSuccess, getPrimaryColor } from '@/utils'
  const primaryColor = getPrimaryColor()

  interface Props {
    id: string
    phone: string
    /** 场景值
     * 001 查寄件手机号
     * 002 收件手机号
     * 003 下单人手机号
     * 004 反查WEB用户表员工手机号
     * 005 反查代理表代理负责人手机号
     * 006 反查合作快递员表快递员手机号
     * 007 反查客户关系管理表代理客户手机号
     * 008 反查客户信息管理表手机号
     * 009 派件表收件人手机号
     * 010 反查问题反馈表反馈人手机号
     * 011 反查交接记录表操作人手机号
     * 012 反查登录设备管理表登录手机号
     * 013 反查讯息表接收人手机号
     * 014 反查修改密码历史记录表手机号
     * 015 反查修改密码历史记录表邮箱
     * 016 反查退件打印表账号
     * 017 反查驿站员工表驿站员工手机号
     * 018 反查驿站员工表邮箱
     * 019 驿站表负责人手机号
     * 020 驿站表邮箱
     * 021 反查驿站表驿站员工身份证
     * 022 签收图片合格率报表反查驿站员工表驿站员工手机号
     * 023 员工派件列表反查驿站员工表驿站员工手机号
     **/
    scenes: '001' | '002' | '003' | '004' | '005' | '006' | '007' | '008' | '009' | '010' | '011' | '012' | '013' | '014' | '015' | '016' | '017' | '018' | '019' | '020' | '021' | '022' | '023' | string
    menuName: string
    optType: 'DETAIL' | 'LIST' | 'SENDER' | 'RECEIVER'
  }
  const props = defineProps<Props>()
  const phone = computed({
    get() {
      state.showEye = true
      return props.phone || ''
    },
    set(val) {
      // props.phone = val
    }
  })
  /**查看手机号 */
  const state = reactive({
    /** 加载中 */
    loading: false,
    /** 显示眼睛 */
    showEye: true,
    /** 结果 */
    result: ''
  })

  const getCardId = () => {
    if (!state.showEye) {
      state.showEye = !state.showEye
      return
    }
    state.loading = true
    getPhoneService
      .getPhone({
        key: props.id,
        code: props.scenes,
        menuName: props.menuName,
        optType: props.optType || 'LIST'
      })
      .then((res) => {
        if (isSuccess(res)) {
          state.result = res.data
        }
        console.log('res', res)
      })
      .catch((err) => {
        console.log('err', err)
      })
      .finally(() => {
        state.loading = false
        state.showEye = !state.showEye
      })
  }
</script>
<style lang="less" scoped>
  .decrypt {
    display: flex;
    justify-content: center;
    align-items: center;
    &.start {
      justify-content: flex-start;
    }
    .flex_1 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .real-user-show {
      cursor: pointer;
      margin-left: 4px;
    }
  }
</style>
